import { motion, useScroll, useSpring } from "framer-motion";
import "./style.css";
//
export default function ScrollBar() {
  const { scrollYProgress } = useScroll(0);
  const scaleX = useSpring(scrollYProgress, {
    // 增加动画延迟
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });
  return <motion.div className="progress-bar" style={{ scaleX }} />;
}
